module.exports = __webpack_public_path__ + "media/images/ecalls/02_why_e_calls_logo_bg-b7da548b87269a8eb333306a08a55eaf.png";